<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="rounded">
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card-title class="justify-center">Editar</v-card-title>
        <v-card-text>
          <v-row class="justify-center">
            <v-radio-group v-model="operation" row>
              <v-col>
                <v-radio value="ticket" label="Ticket"></v-radio>
              </v-col>
              <v-col>
                <v-radio value="invoice" label="Factura"></v-radio>
              </v-col>
            </v-radio-group>
          </v-row>
        </v-card-text>
        <v-card-text>
          <div v-if="operation === 'invoice'">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0 d-flex">
                <v-text-field
                  type="text"
                  v-model="input.email"
                  label="Email"
                  :rules="[rules('Email').required]"
                  hide-details="auto"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-0 pb-0 d-flex">
                <v-text-field
                  name="name"
                  type="text"
                  v-model="input.name"
                  label="Nombre/Empresa"
                  :rules="[rules('Nombre/Empresa').required]"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex pt-0 pb-0">
                <v-text-field
                  :rules="[rules('NIF').required]"
                  hide-details="auto"
                  v-model="input.nif"
                  label="NIF"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex pt-0 pb-0">
                <v-text-field
                  :rules="[rules('Código Postal').required]"
                  hide-details="auto"
                  v-model="input.postal_code"
                  label="Código Postal"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex pt-0 pb-0">
                <v-text-field
                  :rules="[rules('Ciudad').required]"
                  hide-details="auto"
                  v-model="input.city"
                  label="Ciudad"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex pt-0 pb-0">
                <v-textarea
                  :rules="[rules('Dirección').required]"
                  hide-details="auto"
                  name="input-7-1"
                  v-model="input.address"
                  label="Dirección"
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
          <div v-if="operation === 'ticket'">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0 d-flex">
                <v-text-field
                  type="text"
                  v-model="input.email"
                  label="Email"
                  :rules="[rules('Email').required]"
                  hide-details="auto"
                />
              </v-col>
            </v-row>
          </div>
          <v-row class="justify-center">
            <v-btn
              @click="dialog = false"
              color="light"
              text
              style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              type="submit"
              color="light"
              text
              style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </v-row>
          <br />
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import firebaseMixin from "@/mixins/firebase/firebaseMixin.js";

export default {
  mixins: [firebaseMixin],
  data: () => ({
    operation: "ticket",
    input: {},
    details: null,
    dialog: false
  }),
  methods: {
    open(details) {
      this.dialog = true;
      this.operation = details.invoiceRequest ? "invoice" : "ticket";
      this.input = { ...details.company };
      this.details = { ...details };
      console.log(this.input);
    },
    async submit() {
      if (this.operation === "invoice" && this.$refs.form.validate()) {
        this.details.invoiceRequest = true;
        this.details.company = this.input;
        if (!this.details.legal_number) {
          this.details.legal_number = await this.getNextInvoiceNumber();
        }

        this.$emit("editDetails", { ...this.details });
        this.showSuccessMessage("Cambio Realizado con Exito");
        this.dialog = false;
      } else if (this.operation === "ticket") {
        this.details.company = { email: this.input.email };
        this.details.invoiceRequest = false;

        this.$emit("editDetails", this.details);
        this.showSuccessMessage("Cambio Realizado con Exito");
        this.dialog = false;
      }
    },
    rules(name) {
      return {
        required: v => !!v || `${name} es requerido`
      };
    }
  }
};
</script>

<style></style>
